import {DialogForm} from "../ui/dialog-form/dialog-form";

export const HeroFormsMobile = () => {
  
  return (
    <div className="hidden w-full mt-[30px] screen-1220:grid gap-2 screen-900:landscape:mt-2">
      <DialogForm title={'ПСК: 17,571% – 17,847% Семейная ипотека от 6%'} celtype='getHeroMortgage'>
        <button
          className="flex justify-center items-center bg-plt-secondary rounded-xl px-8 py-[18px] w-[310px] screen-950:landscape:py-2 font-open-sans-condensed mx-auto screen-700:w-full screen-700:rounded-5px">
            <span className="text-plt-white text-xl font-bold shrink-0 tracking-[-3%] screen-500:text-base">
              ПСК: 17,571% – 17,847% <br/> Семейная ипотека от 6%
            </span>
        </button>
      </DialogForm>

      <DialogForm title={'Рассрочка 0%'} celtype='getHeroInstallment'>
        <button
          className="flex justify-center items-center bg-plt-secondary rounded-xl px-8 py-[18px] w-[310px] screen-950:landscape:py-2 font-open-sans-condensed mx-auto screen-700:w-full screen-700:rounded-5px">
            <span className="text-plt-white text-xl font-bold shrink-0 tracking-[-3%] screen-500:text-base">
              Рассрочка 0%
            </span>
        </button>
      </DialogForm>
    </div>
  );
};
